import { z } from 'zod';

export const GenerateResponseSchema = z.object({
  token: z.string(),
  expiresAt: z.string(),
  redirectUrl: z.string(),
});
export type GenerateResponse = z.infer<typeof GenerateResponseSchema>;

export const ExchangeResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  workspaceId: z.string().nullable(),
  companyId: z.string(),
  expiresAt: z.string(),
  user: z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    role: z.string().nullable(),
  }),
});
export type ExchangeResponse = z.infer<typeof ExchangeResponseSchema>;

export const SessionSchema = z.object({
  id: z.string(),
  superAdminId: z.string(),
  superAdminEmail: z.string(),
  targetUserId: z.string(),
  targetUserEmail: z.string(),
  companyId: z.string(),
  companyName: z.string(),
  workspaceId: z.string().nullable(),
  workspaceName: z.string().nullable(),
  reason: z.string(),
  generatedAt: z.string(),
  exchangedAt: z.string().nullable(),
  endedAt: z.string().nullable(),
  durationSeconds: z.number().nullable(),
  actionsCount: z.number(),
  // Customer-facing enum (Title Case) per HFv3 enum convention.
  status: z.enum(['Unused', 'Active', 'Completed', 'Expired']),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
});
export type ImpersonationSession = z.infer<typeof SessionSchema>;

export const SessionsListSchema = z.object({
  data: z.array(SessionSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});
export type SessionsList = z.infer<typeof SessionsListSchema>;
